import { useCallback, useEffect, useState } from "react";

export type MicPermissionStatus = "granted" | "denied" | "prompt";

export function useMicrophonePermission() {
  const [status, setStatus] = useState<MicPermissionStatus>("prompt");

  useEffect(() => {
    if (!navigator.permissions?.query) return;

    let permissionStatus: PermissionStatus | undefined;
    const handleChange = () => {
      if (permissionStatus)
        setStatus(permissionStatus.state as MicPermissionStatus);
    };

    navigator.permissions
      .query({ name: "microphone" as PermissionName })
      .then((result) => {
        permissionStatus = result;
        setStatus(result.state as MicPermissionStatus);
        result.addEventListener("change", handleChange);
      })
      .catch(() => {});
    // eslint-disable-next-line
    return () => permissionStatus?.removeEventListener("change", handleChange);
  }, []);

  const requestPermission = useCallback(async () => {
    try {
      const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
      stream.getTracks().forEach((track) => track.stop());
      setStatus("granted");
      return true;
    } catch {
      setStatus("denied");
      return false;
    }
  }, []);

  return { status, requestPermission };
}
